import { securityLevelOptions } from '@/domain/products/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Tooltip } from '@andritzot/metris-web-ui/data-display/tooltip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface SecurityContentProps {
  productSecurityLevel: number;
}

export const SecurityContent = ({ productSecurityLevel }: SecurityContentProps) => {
  const option = securityLevelOptions.find((c) => c.value === productSecurityLevel);
  if (!option) {
    return null;
  }
  const chipTitle = `Security Level ${option.value}`;

  const tooltipText = `${option.tooltip}`;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2 }}>
      <Tooltip title={tooltipText}>
        <Chip label={chipTitle} variant="outlined" color="success" />
      </Tooltip>
    </Box>
  );
};
